import type { ModuleMigrationDef } from "@kubdee/sdk";

export const migration: ModuleMigrationDef = {
  key: "001_initial",
  version: "1.0.0",
  sql: `
CREATE TABLE IF NOT EXISTS \`purchase_orders\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`po_no\` text NOT NULL,
	\`company_id\` text NOT NULL,
	\`branch_id\` text,
	\`party_type\` text DEFAULT 'supplier' NOT NULL,
	\`party_id\` text NOT NULL,
	\`po_date\` text NOT NULL,
	\`expiry_date\` text,
	\`subtotal\` real DEFAULT 0 NOT NULL,
	\`tax_amount\` real DEFAULT 0 NOT NULL,
	\`total\` real DEFAULT 0 NOT NULL,
	\`status\` text DEFAULT 'draft' NOT NULL,
	\`converted_to_invoice_id\` text,
	\`remarks\` text,
	\`created_by\` text,
	\`created_at\` text NOT NULL,
	\`updated_by\` text,
	\`updated_at\` text NOT NULL,
	\`deleted_by\` text,
	\`deleted_at\` text
);
CREATE UNIQUE INDEX IF NOT EXISTS \`purchase_orders_po_no_unique\` ON \`purchase_orders\` (\`po_no\`);
CREATE INDEX IF NOT EXISTS \`po_company_status_idx\` ON \`purchase_orders\` (\`company_id\`,\`status\`,\`po_date\`);
CREATE INDEX IF NOT EXISTS \`po_company_party_idx\` ON \`purchase_orders\` (\`company_id\`,\`party_id\`);
CREATE INDEX IF NOT EXISTS \`po_converted_idx\` ON \`purchase_orders\` (\`converted_to_invoice_id\`);
CREATE TABLE IF NOT EXISTS \`purchase_order_items\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`purchase_order_id\` text NOT NULL,
	\`item_id\` text,
	\`description\` text,
	\`qty\` real DEFAULT 1 NOT NULL,
	\`rate\` real DEFAULT 0 NOT NULL,
	\`amount\` real DEFAULT 0 NOT NULL,
	\`account_id\` text,
	\`tax_template_id\` text,
	\`tax_amount\` real DEFAULT 0 NOT NULL,
	\`sort_order\` integer DEFAULT 0 NOT NULL,
	\`created_at\` text NOT NULL,
	FOREIGN KEY (\`purchase_order_id\`) REFERENCES \`purchase_orders\`(\`id\`) ON UPDATE no action ON DELETE no action,
	FOREIGN KEY (\`item_id\`) REFERENCES \`accounting_items\`(\`id\`) ON UPDATE no action ON DELETE no action,
	FOREIGN KEY (\`account_id\`) REFERENCES \`accounting_accounts\`(\`id\`) ON UPDATE no action ON DELETE no action,
	FOREIGN KEY (\`tax_template_id\`) REFERENCES \`accounting_tax_templates\`(\`id\`) ON UPDATE no action ON DELETE no action
);
CREATE INDEX IF NOT EXISTS \`poi_purchase_order_idx\` ON \`purchase_order_items\` (\`purchase_order_id\`);
  `.trim(),
};
